import { DatePicker } from "@mui/x-date-pickers";
import BaseListagem from "components/BaseListagem";
import dayjs from "dayjs";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column, ColumnFilterElementTemplateOptions } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { MultiSelect, MultiSelectChangeEvent } from "primereact/multiselect";
import { useEffect, useState } from "react";
import NotaFiscalEntradaService from "service/suprimentos/NotaFiscalEntradaService";
import { converterDataHora } from "utils/convert";
import { DateMatchModeOptions, IdMatchModeOptions, ListMatchModeOptions, TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const notaFiscalEntradaService = new NotaFiscalEntradaService();

export default function NotaFiscalEntradaListagem() {

    const [fornecedores, setFornecedores] = useState<any[]>([]);

    const [usuarios, setUsuarios] = useState<any[]>([]);

    useEffect(() => {
        notaFiscalEntradaService.getFornecedores().then(response => setFornecedores(response)).catch(() => setFornecedores([]));
        console.log(fornecedores)
    }, []);

    useEffect(() => {
        notaFiscalEntradaService.getUsuarios().then(response => setUsuarios(response)).catch(() => setUsuarios([]));
        console.log(usuarios)
    }, []);


    const defaultFilters: DataTableFilterMeta = {
        dataRecebimento: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },

        fornecedor: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },

        numero: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },

        usuario: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },

        status: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.IN,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    const fornecedorFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={fornecedores}
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const usuarioFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <Dropdown value={options.value} options={usuarios} filter
            onChange={(e) => options.filterCallback(e.value)}
            optionLabel="nome" optionValue="id" placeholder="Qualquer" className="p-column-filter" />
    }

    const statusFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <MultiSelect value={options.value} options={notaFiscalEntradaService.getStatusNotaFiscalEntradaFilter()}
            onChange={(e: MultiSelectChangeEvent) => options.filterCallback(e.value)}
            optionLabel="label" optionValue="value" placeholder="Qualquer" className="p-column-filter"
        />;
    };

    const dateFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <DatePicker
            value={dayjs(options.value)}
            onChange={value =>
                options.filterCallback(value?.toDate(), options.index)
            }
        />

    };

    const numeroNotaFilterTemplate = (options: ColumnFilterElementTemplateOptions) => {
        return <InputText type="number" value={options.value} className="p-column-filter"
            onKeyDown={(e) => {
                if ([".", ",", "-", "e", "E", "+", "-", "=", "*", "/", "%", "&", "(", ")", "!", "?", "@", "#", "$", "%", "¨", "^", "~", "´", "`", "{", "}", "[", "]", "|", ";", ":", "<", ">"].includes(e.key)) {
                    e.preventDefault()
                }
            }}
            onChange={(e) => {
                options.filterCallback(e.target.value)
            }}
        />;
    };

    return (

        <BaseListagem ordenacao="dataRecebimento,DESC" service={notaFiscalEntradaService} urlService="/notaFiscalEntrada" tituloPagina={'Nota Fiscal de Entrada'} defaultFilters={defaultFilters} showClearFilterButton nome="notaFiscalEntrada" >
            <Column field="dataRecebimento" body={(rowData) => rowData.dataRecebimento ? converterDataHora(rowData.dataRecebimento) : ""} header="Data Recebimento" style={{ width: '10em' }}
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={DateMatchModeOptions}
                filterApply={filterApplyTemplate} filterElement={dateFilterTemplate} filterMenuStyle={{ zIndex: 50 }} />

            <Column field="fornecedor.nome" header="Fornecedor" filterField="fornecedor"
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                filterElement={fornecedorFilterTemplate} />

            <Column field="numero" header="Número"
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterElement={numeroNotaFilterTemplate} filterApply={filterApplyTemplate} />

            <Column field="usuario.nome" header="Usuário" filterField="usuario"
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={IdMatchModeOptions} filterApply={filterApplyTemplate}
                filterElement={usuarioFilterTemplate} />

            <Column field="status" body={(rowData) => notaFiscalEntradaService.getStatus(rowData.status)} header="Status"
                filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={ListMatchModeOptions} filterApply={filterApplyTemplate} filterElement={statusFilterTemplate} />

        </BaseListagem>
    )
}
